const getInitialvalues = (filters) => {
  return {
    customer_id: filters.customer_id || [],
    reference_id: filters.reference_id || [],
    bank_id: filters.bank_id || [],
    followup_date_from: filters.followup_date_from || null,
    followup_date_to: filters.followup_date_to || null,

    bank_invoice_status_id: filters.bank_invoice_status_id || [],
    bank_invoice_status_name: filters.bank_invoice_status_name || [],
    created_at_from: filters.created_at_from || null,
    created_at_to: filters.created_at_to || null,
    payment_date_from: filters.payment_date_from || null,
    payment_date_to: filters.payment_date_to || null,

    year: filters.year|| "",
    month: filters.month|| "",
    expected_payment_type:  filters.expected_payment_type|| "",
    payment_method_id: filters.payment_method_id|| [],

    due_amount_from: filters.due_amount_from || "",
    due_amount_to: filters.due_amount_to || "",
    paid_amount_from: filters.paid_amount_from || "",
    paid_amount_to: filters.paid_amount_to || "",
  };
};

export default getInitialvalues;
